module.exports = __webpack_public_path__ + "img/heart.c9b95d6a.svg";